define(["data/config"], function(config) {

    var apply = function($element, params) {
        $('#discountLabel').on("click", function(e) {
            $('#discountInput').toggleClass('u_hidden');

            if ($('#discountInput').hasClass('u_hidden')) {
                $('#discountArrow').css({transform: 'rotate(0deg)', transition: 'transform 0.1s linear', display: 'inline-block'})
            } else {
                $('#discountArrow').css({transform: 'rotate(-90deg)', transition: 'transform 0.1s linear', display: 'inline-block'})
            }
        });

        $('#discountConfirmButton').on("click", function(e) {
            e.preventDefault();
            let redirect = new URL(window.location.href);
            redirect.searchParams.set('code', document.querySelector('#discountInput > input').value);

            window.location = redirect.href;
        });
    };

    return {
        name: "discountBox",
        apply: apply
    };
});
